<template>
  <div style="text-align: left;">
    <el-card class="box-card" v-for="item in data" :key="item.title" style="margin-top: 12px;">
      <el-row>
        <el-col :span="12">
          <h3>{{item.title}}</h3>
          <div v-for="desc in item.desc">
            {{desc}}
          </div>
        </el-col>
        <el-col :span="12">
          <img :src="item.pic" class="image">
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        data: [{
          title: 'Novel nanobiomaterials for global health and global development applications',
          desc: [
            'GOAL: Develop novel inexpensive nanobiomaterials with improved mechanical, optical, and electrical properties suitable for a wide range of applications ',
            '•  Nanomanufacturing of nanocomposite materials',
            '•  Characterization of these materials ',
            '•  Applications in biosensing, antimicrobial, water purification, and clean energy',
          ],
          pic: 'http://image.ibb.co/bHZjtR/project3.png'
          
          
          
        },{
          title: 'Biosensing with Raman and Plasmonics(Surface Enhanced Raman Spectroscopy)',
          desc: [
            'GOAL: Develop novel biosensing capabilities for the detection and characterization of molecules and sub-micrometer organelles (such as exosomes)',
            '•  Nanomanufacturing and characterization of plasmonic substrates',
            '•  Functionalization of substrates with aptamers or antibodies for specific detection of molecules of interest',
            '•  Analytical measurements and chemical characterization',
          ],
          pic: 'http://preview.ibb.co/c54WOR/projejct2_2.jpg'
        },{
        title: 'Integration and miniaturization of optical technologies for inexpensive and portable diagnosis',
          desc: [
            'GOAL: Develop photonic technologies for diagnosis in remote locations',
            '                                                                 ',
            '•  Microscopy, spectroscopy and light scattering on a cell phone',
            '•  Rapid, automated blood count on a portable platform using very small amounts of blood',
          ],
          pic: 'http://preview.ibb.co/dY8rOR/project1_3.png'  

        }]
      };
    },
    methods: {}
  };
</script>

<style scoped>

  .image {
    float: right;
    width: 300px;
    max-height: 100%;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/content/Research.vue